<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import store from '../../../store';
import SkiDatePicker from '../../../components/ski/rental/SkiDatePicker';
import i18n from '../../../i18n';
import numberMixin from '../../../mixins/numberMixin';
import Vue from 'vue';
import TwCopyAndTranslateModal from '../../../components/TwCopyAndTranslateModal.vue';

export default {
  name: 'SkiRentalSeasonPriceSettings',
  components: {
    TwCopyAndTranslateModal,
    SkiDatePicker,
  },
  mixins: [ numberMixin ],
  props: {
    seasonId: {
      type: [ Number, String ],
      default: null,
    },
    new: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      seasonItem: Object.assign({}, this.season),
      currentPeriodItem: undefined,
      availableNetOrGross: [
        {
          id: 'net',
          name: 'Net',
        },
        {
          id: 'gross',
          name: 'Gross',
        },
      ],
      doRedirectToNewSeason: false,
      copyAndTranslateModalOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      suppliers: 'skirental/getSkiSuppliers',
      periodDates: 'skirental/getPeriodDates',
      availableSalesRules: 'skirental/getSalesTypes',
    }),
    ...mapState({
      season: state => state.skirental.season,
      xmlChannels: state => state.twenty.xmlChannels,
      newPeriodItem: state => state.skirental.season.periodDates.newPeriodItem,
      seasonItemsLoading: state => state.skirental.season.itemsLoading,
      seasonItemsError: state => state.skirental.season.itemsError,
      seasonSaveLoading: state => state.skirental.season.saveLoading,
      seasonSaveError: state => state.skirental.season.saveError,
      suppliersLoading: state => state.skirental.suppliers.itemsLoading,
      suppliersError: state => state.skirental.suppliers.itemsError,
      salesTypesLoading: state => state.skirental.salesTypes.itemsLoading,
      salesTypesError: state => state.skirental.salesTypes.itemsError,
      periodDatesLoading: state => state.skirental.season.periodDates.itemsLoading,
      periodDatesSaveLoading: state => state.skirental.season.periodDates.saveLoading,
      selectedDomainId: state => state.ski.selectedDomainId,
      domains: state => state.twenty.domains.items,
    }),
    errorOccurred() {
      return this.seasonItemsError || this.seasonSaveError || this.salesTypesError;
    },
    selectSupplierLabel() {
      const totalSuppliers = Object.keys(this.suppliers).length;
      return totalSuppliers
        ? '(found '.concat(totalSuppliers.toString()).concat(' suppliers)')
        : '';
    },
    isNewPeriodDateActive() {
      return this.periodDates.some(periodDate => periodDate.id === undefined);
    },
    getCopyValues() {
      return [
        {
          globalModelId: this.seasonItem.id,
          globalModelColumnName: 'ski_rental_season_id',
          selectKeyOverrides: [ 'domain_id', 'ski_rental_season_id' ],
          tableName: 'domain_ski_rental_season',
          sourceDomainId: null,
          selectedFromDomain: null,
          fromLanguageIsoOverride: null,
          sourceIsoOverride: null,
          disableSourceIsoOverride: true,
          toDomains: [],
          shouldTranslate: false,
          shouldCopySeo: false,
          fieldNamesAndValuesToCopyAndTranslate: [
            { information_text: this.seasonItem.informationText },
            { name: this.seasonItem.name },
            { domain_id: null },
            { ski_rental_season_id: this.seasonItem.id },
          ],
          title: `ski rental season: ${this.seasonItem.name}`,
        },
      ];
    },
  },
  watch: {
    season: {
      deep: true,
      handler() {
        if (this.doRedirectToNewSeason
          && this.seasonItem.id === undefined
          && this.season.id !== undefined
        ) {
          this.doRedirectToNewSeason = false;
          this.$router.push(`/ski/rental/season/${this.season.id}`);
          this.$emit('newSeasonCreated', { seasonId: this.season.id });
        }
        this.seasonItem = Object.assign({}, this.season);
      },
    },
    selectedDomainId() {
      this.handleDomains();
    },
  },
  methods: {
    ...mapActions({
      loadSeason: 'skirental/seasonWithRelationsBySeasonIdLoad',
      loadPeriodDates: 'skirental/periodDatesByIdLoad',
      loadSuppliers: 'skirental/suppliersLoad',
      loadAvailableSalesTypes: 'skirental/salesTypesLoad',
      setSeason: 'skirental/setSeason',
      createSeason: 'skirental/seasonCreate',
      saveSeason: 'skirental/seasonSave',
      setPeriodDateItem: 'skirental/setPeriodDateItem',
      periodDateAddNew: 'skirental/periodDateAddNew',
      periodDateCreate: 'skirental/periodDateCreate',
      removePeriodDate: 'skirental/periodDateRemove',
      clonePeriodDate: 'skirental/periodDateClone',
      periodDateUpdate: 'skirental/periodDateUpdate',
    }),
    handleDomains() {
      if (this.selectedDomainId !== null) {
        if (!this.seasonItem.domains) {
          Vue.set(this.seasonItem, 'domains', {});
        }
        if (!this.seasonItem.domains[this.selectedDomainId]) {
          Vue.set(this.seasonItem.domains, this.selectedDomainId, {
            domainId: this.selectedDomainId,
            name: '',
            informationText: '',
          });
        }
      }
    },
    createOrUpdate() {
      if (this.seasonItem.id) {
        this.saveSeason(this.seasonItem);
      } else if (this.createSeason(this.seasonItem)) {
        this.doRedirectToNewSeason = true;
      }
    },
    doRefresh() {
      this.loadSeason(this.season.id);
      this.loadPeriodDates(this.season.id);
    },
    allowedPeriodDates(date) {
      return this.currentPeriodItem && date >= this.currentPeriodItem.arrivalFrom;
    },
    onChange(payload) {
      this.setSeason(payload);
    },
    onPeriodChange(params) {
      let periodDateItem = Object.assign({}, params.periodDate);
      periodDateItem = {
        ...periodDateItem,
        ...params.params,
      };
      let parameters = Object.assign({}, params.params);
      if (params.params.arrivalFrom
        && (params.params.arrivalFrom > periodDateItem.arrivalTo
        || periodDateItem.arrivalTo === undefined
        )
      ) {
        periodDateItem.arrivalTo = params.params.arrivalFrom;
        const arrivalToParams = {
          arrivalTo: params.params.arrivalFrom,
        };
        parameters = {
          ...parameters,
          ...arrivalToParams,
        };
      }
      this.currentPeriodItem = periodDateItem;
      this.setPeriodDateItem(
        {
          periodItem: params.periodDate,
          params: parameters,
        },
      );
      if (params.periodDate.id) {
        const payload = {
          skiRentalSeasonId: params.periodDate.skiRentalSeasonId,
          skiRentalPeriodId: params.periodDate.id,
          skiRentalPeriod: {
            arrivalFrom: parameters.arrivalFrom ? parameters.arrivalFrom : params.periodDate.arrivalFrom,
            arrivalTo: parameters.arrivalTo ? parameters.arrivalTo : params.periodDate.arrivalTo,
          },
        };
        this.periodDateUpdate(payload);
      }
    },
    onDatePickerFocus(periodDate) {
      this.currentPeriodItem = periodDate;
    },
    periodDateRemove(periodDate) {
      // eslint-disable-next-line no-alert
      if (!periodDate.id || confirm(i18n.t('ski.skiPeriodDate.removeAreYouSure'))) {
        this.removePeriodDate(
          {
            seasonId: periodDate.skiRentalSeasonId,
            periodId: periodDate.id,
          },
        );
      }
    },
    periodDateClone(periodDate) {
      // eslint-disable-next-line no-alert
      if (!periodDate.id || confirm('Are you sure you want to clone this period?')) {
        this.clonePeriodDate(
          {
            seasonId: periodDate.skiRentalSeasonId,
            periodId: periodDate.id,
          },
        ).then(() => {
          this.doRefresh();
        });
      }
    },
    formatDate(date) {
      return date ? this.$moment(date).format('DD-MM-YY') : '';
    },
    onChangeDecimal(key, value) {
      const payload = {};
      payload[key] = parseFloat(value.replace(',', '.'));
      this.onChange(payload);
    },
    formatDecimal(value) {
      return `${value}`.replace('.', ',');
    },
  },
  created() {
    this.handleDomains();
  },
  mounted() {
    if (this.season.id) {
      store.dispatch('skirental/seasonWithRelationsBySeasonIdLoad', this.season.id)
        .finally(() => {
          store.dispatch('skirental/periodDatesByIdLoad', this.season.id)
            .finally(() => {
            });
        });
    } else {
      this.seasonItem = Object.assign({}, this.season);
    }
    if (!this.suppliers.length) {
      this.loadSuppliers();
    }
    if (!this.availableSalesRules.length) {
      this.loadAvailableSalesTypes();
    }
  },
  beforeRouteEnter(to, from, next) {
    if (Object.keys(to.params).length === 0 || to.params.new !== undefined) {
      store.dispatch('skirental/seasonByIdLoad', undefined)
        .finally(() => {
          next();
        });
    }

    if (to.params.seasonId) {
      store.dispatch('skirental/seasonWithRelationsBySeasonIdLoad', to.params.seasonId)
        .finally(() => {
          next();
        });
    }
  },
};
</script>

<template>
  <v-container class="pa-0 pl-4 skirental-season" grid-list-xl>
    <h2 class="d-inline-block">
      {{
        seasonItem.id
          ? $t('ski.skiPriceSettings.title')
          : $t('ski.skiPriceSettings.newSeason')
      }}
    </h2>
    <v-btn
      v-if="seasonItem.id"
      :loading="seasonItemsLoading"
      color="primary success"
      @click="copyAndTranslateModalOpen = !copyAndTranslateModalOpen"
    >
      Copy/translate
    </v-btn>
    <tw-copy-and-translate-modal
      v-if="copyAndTranslateModalOpen"
      :elements-to-handle="getCopyValues"
      :domains="domains"
    />
    <v-btn
      :loading="seasonItemsLoading"
      icon
      @click="doRefresh()"
    >
      <v-icon>cached</v-icon>
    </v-btn>
    <div class="text-center pa-1">
      <v-progress-linear
        v-if="seasonItemsLoading
          || seasonSaveLoading
          || suppliersLoading
          || salesTypesLoading
          || periodDatesLoading
        "
        :indeterminate="true"
      />
    </div>
    <v-alert
      :value="errorOccurred"
      color="error"
      icon="warning"
      outline
    >
      <span v-html="errorOccurred"/>
    </v-alert>
    <v-flex xs6>
      <v-text-field
        :value="seasonItem.name"
        label="Global Name"
        @input="onChange({ name: $event })"
      />
      <v-text-field
        v-if="selectedDomainId !== null"
        v-model="seasonItem.domains[selectedDomainId].name"
        label="Domain Name"
      />
    </v-flex>
    <v-layout>
      <v-flex xs3 md3>
        <v-switch
          :label="$t('ski.skiArea.showOnWeb')"
          :input-value="seasonItem.webActive"
          @change="onChange({ webActive: $event })"
        />
      </v-flex>
      <v-flex xs3 md3>
        <v-switch
          :label="$t('ski.skiPriceSettings.pricesActive')"
          :input-value="seasonItem.active"
          @change="onChange({ active: $event })"
        />
      </v-flex>
    </v-layout>
    <h3>{{ $t('ski.skiPriceSettings.supplier') }}</h3>
    <v-layout>
      <v-flex sm5 xs5>
        <v-autocomplete
          :value="seasonItem.twentySupplierId"
          :items="suppliers"
          :loading="suppliersLoading"
          :disabled="suppliersLoading"
          :label="selectSupplierLabel"
          item-text="name"
          item-value="id"
          clearable
          @change="onChange({ twentySupplierId: $event })"
        />
      </v-flex>
      <v-flex sm2 xs2>
        <v-select
          :value="seasonItem.netOrGross"
          :items="availableNetOrGross"
          :label="$t('ski.skiPriceSettings.netOrGross')"
          item-text="name"
          item-value="id"
          hide-details
          @change="onChange({ netOrGross: $event })"
        />
      </v-flex>
      <v-flex sm2 xs2>
        <v-text-field
          v-if="seasonItem.netOrGross === 'gross'"
          :value="seasonItem.commissionRatio"
          :placeholder="$t('ski.skiPriceSettings.commission')"
          :label="$t('ski.skiPriceSettings.percentageCommission')"
          type="Number"
          min="0"
          hide-details
          @change="onChange({ commissionRatio: $event })"
        />
        <v-text-field
          v-if="seasonItem.netOrGross === 'net'"
          :value="seasonItem.contributionRatio"
          :placeholder="$t('ski.skiPriceSettings.contribution')"
          :label="$t('ski.skiPriceSettings.percentageContribution')"
          type="Number"
          min="0"
          hide-details
          @change="onChange({ contributionRatio: $event })"
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex sm3 xs3>
        <v-select
          :value="seasonItem.salesRule"
          :items="availableSalesRules"
          :loading="salesTypesLoading"
          :label="$t('ski.skiPriceSettings.rule')"
          item-text="name"
          item-value="id"
          hide-details
          @change="onChange({ salesRule: $event })"
        />
      </v-flex>
      <v-flex sm2 xs2>
        <v-text-field
          :value="formatDecimal(seasonItem.priceAdjustmentValue)"
          label="Price Adjustment Value"
          hint="This value is multiplied with all prices prior to any calculations"
          persistent-hint
          reverse
          @change="onChangeDecimal('priceAdjustmentValue', $event)"
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs2 md3>
        <v-text-field
          :value="seasonItem.bookDaysBeforeArrival"
          label="Book days before arrival"
          type="Number"
          min="0"
          hide-details
          @change="onChange({ bookDaysBeforeArrival: $event })"
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex sm8>
        <v-textarea
          :value="seasonItem.informationText"
          label="Global Customer information text"
          box
          @change="onChange({ informationText: $event })"
        />
        <v-textarea
          v-if="selectedDomainId !== null"
          v-model="seasonItem.domains[selectedDomainId].informationText"
          label="Domain Customer information text"
          box
        />
      </v-flex>
    </v-layout>
    <div class="text-xs-right pr-3">
      <v-btn
        :disabled="seasonSaveLoading"
        color="primary"
        @click="createOrUpdate"
      >
        {{ seasonItem.id ? $t('buttons.save') : $t('buttons.create') }}
      </v-btn>
    </div>
    <v-layout>
      <v-flex sm8 xs12>
        <v-autocomplete
          v-model="seasonItem.xmlChannelId"
          :items="xmlChannels.items"
          :loading="xmlChannels.itemsLoading"
          :disabled="xmlChannels.itemsLoading"
          :error="xmlChannels.itemsError"
          label="XML Channel"
          item-text="webservice"
          item-value="id"
          class="mt-3"
          clearable
        />
      </v-flex>
      <v-flex sm4 xs4>
        <v-switch
          :input-value="seasonItem.xmlPriceUpdateActivated"
          label="Price update"
          @change="onChange({ xmlPriceUpdateActivated: $event })"
        />
      </v-flex>
    </v-layout>
    <v-flex sm8 xs8>
      <h3 class="d-inline-block">{{ $t('ski.skiPriceSettings.periodDates') }}</h3>
      <v-btn
        :disabled="!season.id
          || isNewPeriodDateActive
          || periodDatesLoading
          || periodDatesSaveLoading
        "
        class="mb-2"
        color="success"
        small
        outline
        @click="periodDateAddNew"
      >
        {{ $t('ski.skiPeriodDate.new') }}
      </v-btn>
      <v-flex class="text-xs-right" md8 xs8>
        <div class="text-center">
          <v-progress-linear
            v-if="seasonItemsLoading || periodDatesLoading || periodDatesSaveLoading"
            :indeterminate="true"
          />
        </div>
      </v-flex>
      <v-flex
        v-if="!periodDates.length"
        v-show="!seasonItemsLoading && !periodDatesLoading && !periodDatesSaveLoading"
        xs12
        md3
      >
        <v-chip
          color="red"
          class="text"
          size="1"
          outline
        >
          {{ season.id
            ? $t('ski.skiPriceSettings.noPeriodDatesFound')
            : $t('ski.skiPriceSettings.pleaseCreateSeasonBeforePeriodDates')
          }}
        </v-chip>
      </v-flex>
      <v-layout
        v-for="(periodDate, index) in periodDates"
        :key="'ski-period-date-' + index"
        class="ma-2"
        xs12
        fill-height
        row
      >
        <v-layout v-if="periodDate.id">
          <v-flex class="text-xs-right" md2 xs12>
            <v-chip
              v-if="periodDate.isActive"
              color="green"
              class="text"
              size="3"
              small
              outline
            >
              {{ $t('ski.skiPriceSettings.active') }}
            </v-chip>
            <v-chip
              v-else
              color="red"
              class="text"
              size="1"
              small
              outline
            >
              {{ $t('ski.skiPriceSettings.historically') }}
            </v-chip>
          </v-flex>
          <v-flex class="text-md-center sm3 xs12" @mouseover="onDatePickerFocus(periodDate)">
            <ski-date-picker
              :date.sync="periodDate.arrivalFrom"
              :title="$t('skiRental.dataHeaders.arrivalFrom')"
              :disabled="periodDatesLoading || periodDatesSaveLoading"
              @onChange="onPeriodChange({ periodDate, params: { arrivalFrom: $event }})"
            />
          </v-flex>
          <v-flex class="text-md-center sm3 xs12" @mouseover="onDatePickerFocus(periodDate)">
            <ski-date-picker
              :date.sync="periodDate.arrivalTo"
              :allowed-dates="allowedPeriodDates"
              :title="$t('skiRental.dataHeaders.arrivalTo')"
              :disabled="periodDatesLoading || periodDatesSaveLoading"
              @onChange="onPeriodChange({ periodDate, params: { arrivalTo: $event }})"
            />
          </v-flex>
          <v-flex sm2 xs12>
            <v-btn
              :disabled="periodDatesSaveLoading"
              color="error"
              small
              outline
              @click="periodDateRemove(periodDate)"
            >
              {{ $t('buttons.remove') }}
            </v-btn>
          </v-flex>
          <v-flex sm2 xs12>
            <v-btn
              :disabled="periodDatesSaveLoading"
              color="error"
              small
              outline
              @click="periodDateClone(periodDate)"
            >
              CLONE
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout v-else>
          <v-flex
            class="text-xs-right"
            xs12
            md3
            offset-sm1
          >
            <ski-date-picker
              :date.sync="periodDate.arrivalFrom"
              :title="$t('skiRental.dataHeaders.arrivalFrom')"
              :disabled="periodDatesLoading || periodDatesSaveLoading"
              @onChange="onPeriodChange({ periodDate, params: { arrivalFrom: $event }})"
            />
          </v-flex>
          <v-flex xs12 md3>
            <ski-date-picker
              :date.sync="periodDate.arrivalTo"
              :allowed-dates="allowedPeriodDates"
              :title="$t('skiRental.dataHeaders.arrivalTo')"
              :disabled="
                periodDate.arrivalFrom === undefined
                  || periodDatesLoading
                  || periodDatesSaveLoading
              "
              @onChange="onPeriodChange({ periodDate, params: { arrivalTo: $event }})"
            />
          </v-flex>
          <v-flex sm2 xs12>
            <v-btn
              :disabled="periodDatesSaveLoading || !periodDate.arrivalFrom || !periodDate.arrivalTo"
              color="green"
              small
              outline
              @click="periodDateCreate(periodDate)"
            >
              {{ $t('buttons.create') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-flex>
  </v-container>
</template>

<style lang="scss">
  .skirental-season {
    .v-messages {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ski/rental/SkiRentalSeasonPriceSettings.vue